import * as React from "react";
import { Pagination } from "react-admin";

export const CustomPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100, 250, 500]} {...props} />
);
